import addTestimonialClicked from "../events/add-testimonial-clicked.js";
import testimonialDeleted from "../events/testimonial-deleted.js";
import testimonialCreated from "../events/testimonial-created.js";
import testimonialUpdated from "../events/testimonial-updated.js";
import fileInputted from "../events/file-inputted.js";
import fileSent from "../events/file-sent.js";
import progressReceived from "../events/progress-received.js";
import testimonialsReordered from "../events/testimonials-reordered.js";
import reorderBtnClicked from "../events/reorder-btn-clicked.js";
function makeEventRouter() {
    const router = {
        'add-testimonial-clicked': addTestimonialClicked,
        'reorder-btn-clicked': reorderBtnClicked
    };
    const routerWithData = {};
    const formRouterWithData = {
        'form-created': testimonialCreated,
        'form-updated': testimonialUpdated,
        'form-deleted': testimonialDeleted,
        'entities-reordered': testimonialsReordered
    };
    const fileRouterWithData = {
        'file-inputted': fileInputted,
        'file-sent': fileSent,
        'progress-received': progressReceived
    };
    return Object.freeze({
        get,
        getWithData,
        getFormActionWithData,
        getFileActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
    function getFileActionWithData(action) {
        return fileRouterWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
